// @ts-nocheck
// TODO: tighten types after migration
import React from 'react';
import './LogoLoader.css';

const LogoLoader = ({ progress = 0 }) => {
  return (
    <div className="fixed top-0 left-0 w-full h-full bg-white flex justify-center items-center z-[9999]">
      <div className="logo-wrapper relative w-[150px] h-[150px] flex justify-center items-center">
        {/* Base Image: Grayscale */}
        <img
          src="/images/home_images/Logo_Transparent.png"
          alt="Loading base"
          className="logo-loader-image logo-base w-full h-auto block"
        />

        {/* Overlay Image: Color, clipped from bottom */}
        <img
          src="/images/home_images/Logo_Transparent.png"
          alt="Loading progress"
          className="logo-loader-image logo-overlay absolute top-0 left-0 w-full h-full transition-[clip-path] duration-100 linear"
          style={{
            clipPath: `inset(${100 - progress}% 0 0 0)`
          }}
        />
      </div>
      {/* Optional: Percentage Text */}
      {/* <div className="loading-percentage">{Math.round(progress)}%</div> */}
    </div>
  );
};

export default LogoLoader;
